module.exports = __webpack_public_path__ + "img/clas-ingl-02.1e741ca0.jpg";